<fcom-modal
  [fitToContent]="true"
  [buttons]="null"
  [forceRemainOpen]="modalOpen"
  [open]="!!(cookiePolicy$ | async) && modalOpen"
  [fullHeightMobile]="isShowCookieSettings"
  [fullHeight]="true"
  ><div class="cookie-policy mr-large-x mr-small-y">
    <ng-container *ngIf="!isShowCookieSettings">
      <div
        class="cookie-policy-title flex-1 nordic-blue-900 font-heading-2 bold"
        [innerHTML]="cookiePolicy$ | finMap: 'teaserTitle' | async | finSafe: 'html'"
      ></div>
      <div
        class="cookie-policy-text flex-1 mr-small-y grey-800-text font-body-1 regular-type"
        [innerHTML]="cookiePolicy$ | finMap: 'detailText' | async | finSafe: 'html'"
      ></div>
      <div class="flex--nogrow align-center mr-small-t">
        <fcom-button
          [text]="'cookieConsent.allowAllCookies' | finLocalization"
          (click)="quickSetCookies(ConsentStatus.ACCEPTED)"
          [mode]="ButtonMode.FILL"
          [aria]="{ label: 'cookieConsent.allowAllCookies' | finLocalization, role: 'button' }"
          class="mr-xsmall-b font-body-1 fill"
          id="allow-all-btn"
        ></fcom-button>
        <fcom-button
          [text]="'cookieConsent.manageCookies' | finLocalization"
          (click)="showCookieSettings()"
          [theme]="ButtonTheme.SECONDARY"
          [mode]="ButtonMode.FILL"
          [aria]="{ label: 'cookieConsent.manageCookies' | finLocalization, role: 'button' }"
          class="mr-xsmall-b font-body-1 fill"
          id="manage-cookie-btn"
          data-test-change-search-button
        ></fcom-button>
        <fcom-button
          [text]="'cookieConsent.useNecessary' | finLocalization"
          (click)="quickSetCookies(ConsentStatus.DECLINED)"
          [theme]="ButtonTheme.SECONDARY"
          [mode]="ButtonMode.FILL"
          [aria]="{ label: 'cookieConsent.useNecessary' | finLocalization, role: 'button' }"
          id="necessary-cookie-btn"
          class="font-body-1 fill"
        ></fcom-button>
      </div>
    </ng-container>
    <fin-cookie-settings
      data-test-cookie-settings
      *ngIf="isShowCookieSettings"
      [consents$]="consents$"
      (consentDataSelection)="confirmAndClose($event)"
      (modalClose)="closeModal()"
    ></fin-cookie-settings>
    <div class="flex flex--center mr-xsmall-t">
      <fcom-icon name="info" class="icon-medium mr-xsmall-r"></fcom-icon>
      <div class="light-type grey-800-text font-body-1">
        {{ 'cookieConsent.cookiesTips' | finLocalization }}
      </div>
    </div>
  </div>
</fcom-modal>
